import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  Stack,
  Box,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  stepConnectorClasses,
} from '@mui/material';
import moment from 'moment';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import request_E_signIcon from 'assets/svg/request_E_signIcon.svg';
import commence_E_SignIcon from 'assets/svg/commence_E_SignIcon.svg';
import {
  ActionRequiredStatus,
  CheckTick,
  CompletedStatus,
  DepositIconColor,
  Downloaded,
  EyeIcon,
  File,
  FileCopy,
  PendingStatus,
  ShareIcon,
  SignContractColor,
  Todo,
} from './Marketplaceicons';
import { styled, useTheme } from '@mui/styles';
import { poppins300, poppins400 } from 'theme/common.style';
import ActionButtonChecklist from './ActionButtonChecklist';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

export const CheckLists = ({
  groupCall,
  ApicallDueDiligence,
  checkListArray,
  getSteps,
  getBuyerIndividualValue,
  getBuyerIndividualData,
  data,
  dueDelligencedNotFound,
  checkListPop,
  getColor,
  sharedpage,
  setOpenlogin,
  userId,
  openlogin,
  setTabDAta,
  handleMakeOfferClick,
  action,
  uploadDoc,
  openMessage,
  commenceBinder,
  setPaymentPop,
  setOpenBoxSign,
  depositPaymentBuyer,
  setDepositPaymentBuyer,
  signContract,
  setSignContract,
  sixtySixWCertificate,
  setSixtySixWCertificate,
  contractReviewed,
  setContractReviewed,
  viewContractBuyer,
  setViewContractBuyer,
  dueDiligence,
  setDueDiligence,
  propertyInspected,
  setPropertyInspected,
  classes,
  showActivate,
  setRequesttoview,
  setNewTabData,
  isAuction,
  userDetail,
  setOpensolicitorpopup,
  setTypeofsolicitorpopup,
}) => {
  const [expandedPanel, setExpandedPanel] = useState(null);

  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery('(max-width:900px)');
  const matches420 = useMediaQuery(theme.breakpoints.down(420));
  const matches650 = useMediaQuery(theme.breakpoints.down(650));
  const matches600 = useMediaQuery(theme.breakpoints.down(600));

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : null);
  };

  const renderIcon = (taskName) => {
    const iconProps = { color: '#6C2AD2', matches420, matches650 };
    switch (taskName) {
      case 'Property Inspected':
        return <EyeIcon {...iconProps} />;
      case 'Due Diligence':
        return <Todo {...iconProps} />;
      case 'View Contract':
        return <File {...iconProps} />;
      case 'Forward Contract':
        return <ShareIcon {...iconProps} />;
      case 'Contract Reviewed':
        return <FileCopy {...iconProps} />;
      case '66w Certificate':
        return <Downloaded {...iconProps} />;
      case 'Sign Contract':
        return <SignContractColor {...iconProps} />;
      case 'Deposit Payment':
        return <DepositIconColor {...iconProps} />;
      default:
        return null;
    }
  };

  const determineStatusIcon = (task) => {
    if (task?.taskName == 'Deposit Payment') {
      if (task?.taskStatus == 'Processing') {
        return <PendingStatus color="#F39800" />;
      }

      if (task?.taskStatus == 'Processed') {
        return <CompletedStatus color="grey" />;
      }
    }
    const color = getColor(task?.taskStatus);

    if (task?.taskStatus === 'Action Required') {
      return <ActionRequiredStatus color={color} />;
    }

    if (['Reviewed', 'Completed'].includes(task?.taskStatus)) {
      return <CompletedStatus color={color} />;
    }

    return <PendingStatus color={color} />;
  };
  const CustomStepIcon1 = (props) => {
    const { active, completed } = props;

    return (
      <div
        style={{
          zIndex: 10,
          color: completed ? 'white' : 'rgba(230, 242, 255, 1)', // Completed and active steps color
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 24,
          height: 24,
          borderRadius: '50%',
          backgroundColor: completed ? '#6C2AD2' : 'rgba(230, 242, 255, 1)', // Background for active/completed
        }}
      >
        {completed || active ? (
          <CheckTick color={completed ? 'white' : 'rgba(230, 242, 255, 1)'} />
        ) : null}{' '}
        {/* Remove the number for non-active/non-completed steps */}
      </div>
    );
  };

  const CustomConnector = styled(StepConnector)(({ theme }) => ({
    width: '100%',
    marginLeft: '-20px',
    zIndex: 1, // Ensure the line stays behind the icons
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: 12,
    },
    [`&.${stepConnectorClasses.active}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: 'rgba(230, 242, 255, 1)',
      },
    },
    [`&.${stepConnectorClasses.completed}`]: {
      [`& .${stepConnectorClasses.line}`]: {
        backgroundColor: '#6C2AD2',
        zIndex: -10, // Keep the line behind the icons
      },
    },
    [`& .${stepConnectorClasses.line}`]: {
      height: 1.4,
      border: 0,
      backgroundColor: 'rgba(230, 242, 255, 1)',
    },
  }));

  const formatLastUpdated = (date) =>
    date ? moment(date).format('HH:mm DD-MM-YYYY') : '--';

  return (
    <Box>
      {isMobileOrTablet ? (
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            px={2}
            py={1}
            sx={{ width: matches600 ? '90%' : '100%' }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                ...poppins400,
                fontSize: '16px',
                borderBottom: 'none',
              }}
            >
              Task
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                ...poppins400,
                fontSize: '16px',
                borderBottom: 'none',
              }}
            >
              Done
            </Typography>
          </Box>
          <Stack spacing={2}>
            {checkListArray.map((task, index) => {
              const icon = renderIcon(task?.taskName);
              const formattedLastUpdated =
                task?.taskCode == 'SignCon001' &&
                task?.taskStatus == 'Action Required'
                  ? formatLastUpdated()
                  : formatLastUpdated(task?.statusLastUpdatedAt);
              const statusIcon = determineStatusIcon(task);
              const steps = getSteps(task?.taskName);
              const formattedETA = task?.ETA
                ? moment(task?.ETA).format('hh:mm A DD-MM-YYYY')
                : '--';

              if (
                (task?.taskCode == 'SignCon001' ||
                  task?.taskCode == 'DepPay001') &&
                task?.isChecklist == 0
              )
                return null;
              return (
                <Accordion
                  key={index}
                  expanded={expandedPanel === index}
                  onChange={handleAccordionChange(index)}
                  sx={{
                    boxShadow: 'none',
                    border: 'none',
                    '&:before': { display: 'none' },
                  }}
                >
                  <AccordionSummary>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      width={matches600 ? '90%' : '100%'}
                    >
                      <Stack
                        direction="row"
                        aligntasks="center"
                        gap={1}
                        alignItems={'center'}
                      >
                        {icon}
                        <Typography
                          variant="subtitle1"
                          onClick={(event) => {
                            event.stopPropagation();
                            checkListPop(
                              task?.taskName,
                              index,
                              event,
                              task,
                              formattedETA,
                              formattedLastUpdated
                            );
                          }}
                          sx={{
                            ...poppins300,
                            fontSize: matches420
                              ? '16px'
                              : matches650
                              ? '18px'
                              : '20px',
                            marginLeft: '5px',
                            color: '#112347',
                            cursor: 'pointer',
                          }}
                        >
                          {task?.taskName == '66w Certificate'
                            ? 's66W Certificate'
                            : task?.taskName}
                        </Typography>
                        {expandedPanel === index ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )}
                      </Stack>
                      <IconButton edge="start">{statusIcon}</IconButton>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Stack
                      direction={'column'}
                      spacing={2}
                      sx={{ width: matches600 ? '90%' : '100%' }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'poppins',
                          fontSize: '14px',
                          fontWeight: 300,
                        }}
                      >
                        This is a detailed status of your progress for
                        completing the {task?.taskName}.
                      </Typography>
                      <Typography
                        sx={{
                          fontFamily: 'poppins',
                          fontSize: '16px',
                          fontWeight: 500,
                        }}
                      >
                        Status
                      </Typography>
                      <Stack
                        direction={'row'}
                        spacing={2}
                        alignItems={'center'}
                      >
                        <Box
                          sx={{
                            backgroundColor: getColor(
                              task?.taskStatus,
                              task?.taskName
                            ),
                            borderRadius: '5px',
                            ...poppins400,
                            fontSize: '14px',
                            color: '#FFFFFF',
                            whiteSpace: 'nowrap',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            minWidth: 'fit-content',
                            padding: '5px',
                          }}
                        >
                          {' '}
                          {task?.ETA != null &&
                          (task?.taskStatus == 'In Progress' ||
                            task?.taskStatus == 'Requested')
                            ? 'ETA'
                            : task?.taskStatus}{' '}
                          &nbsp;
                          {task?.ETA != null &&
                            (task?.taskStatus == 'In Progress' ||
                              task?.taskStatus == 'Requested') && (
                              <>{formattedETA}</>
                            )}
                        </Box>
                        <ActionButtonChecklist
                          ApicallDueDiligence={ApicallDueDiligence}
                          groupCall={groupCall}
                          data={data}
                          task={task}
                          checkListArray={checkListArray}
                          getBuyerIndividualData={getBuyerIndividualData}
                          getBuyerIndividualValue={getBuyerIndividualValue}
                          sharedpage={sharedpage}
                          openMessage={openMessage}
                          setContractReviewed={setContractReviewed}
                          setDueDiligence={setDueDiligence}
                          setOpenlogin={setOpenlogin}
                          openlogin={openlogin}
                          propertyInspected={propertyInspected}
                          setPropertyInspected={setPropertyInspected}
                          userId={userId}
                          setTabDAta={setTabDAta}
                          handleMakeOfferClick={handleMakeOfferClick}
                          action={action}
                          classes={classes}
                          uploadDoc={uploadDoc}
                          commenceBinder={commenceBinder}
                          setPaymentPop={setPaymentPop}
                          setOpenBoxSign={setOpenBoxSign}
                          depositPaymentBuyer={depositPaymentBuyer}
                          setDepositPaymentBuyer={setDepositPaymentBuyer}
                          signContract={signContract}
                          setSignContract={setSignContract}
                          sixtySixWCertificate={sixtySixWCertificate}
                          setSixtySixWCertificate={setSixtySixWCertificate}
                          contractReviewed={contractReviewed}
                          viewContractBuyer={viewContractBuyer}
                          setViewContractBuyer={setViewContractBuyer}
                          dueDiligence={dueDiligence}
                          request_E_signIcon={request_E_signIcon}
                          commence_E_SignIcon={commence_E_SignIcon}
                          setRequesttoview={setRequesttoview}
                          setNewTabData={setNewTabData}
                          userDetail={userDetail}
                          setOpensolicitorpopup={setOpensolicitorpopup}
                          setTypeofsolicitorpopup={setTypeofsolicitorpopup}
                        />
                      </Stack>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontSize: '14px',
                          fontFamily: 'poppins',
                          fontWeight: '500',
                        }}
                      >
                        Last Updated:
                        {task?.statusLastUpdatedAt
                          ? formattedLastUpdated
                          : '--'}
                      </Typography>
                      <Stack
                        sx={{
                          width: '100%',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: '20px',
                          marginTop: '20px',
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'poppins',
                            fontSize: '16px',
                            fontWeight: 500,
                          }}
                        >
                          Current Progress
                        </Typography>
                        <Stepper
                          sx={{ zIndex: 0 }}
                          alternativeLabel
                          activeStep={
                            task?.taskName == 'Due Diligence' &&
                            data?.StrataLink?.propertyMedia == '' &&
                            data?.BuildingPestLink?.propertyMedia == ''
                              ? 0
                              : task?.taskStatus == 'Completed' ||
                                task?.taskStatus == 'Reviewed'
                              ? 3
                              : task?.taskStatus == 'Requested' ||
                                task?.taskStatus == 'Pending Buyer Signature' ||
                                task?.taskStatus == 'Pending' ||
                                task?.taskStatus == 'Processing' ||
                                task?.taskStatus == 'Scheduled' ||
                                task?.taskStatus == 'In Progress'
                              ? 2
                              : 1
                          }
                          connector={<CustomConnector />} // Use the customized connector
                        >
                          {Array.isArray(steps) &&
                            steps?.map((label) => (
                              <Step key={label}>
                                <StepLabel
                                  StepIconComponent={CustomStepIcon1}
                                  sx={{
                                    '.MuiStepLabel-label': {
                                      fontFamily: 'Poppins, sans-serif',
                                      whiteSpace: 'nowrap',
                                      fontWeight: '300 !important',
                                      fontSize: '10px',
                                      marginTop: '5px',
                                    },
                                  }}
                                >
                                  {label}
                                </StepLabel>
                              </Step>
                            ))}
                        </Stepper>
                      </Stack>
                    </Stack>
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Stack>
        </Box>
      ) : (
        <TableContainer>
          <Table sx={{ borderCollapse: 'separate', borderSpacing: 0 }}>
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  sx={{
                    ...poppins400,
                    fontSize: '14px',
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    padding: '16px',
                  }}
                >
                  Task
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    ...poppins400,
                    fontSize: '14px',
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    padding: '16px',
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    ...poppins400,
                    fontSize: '14px',
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    padding: '16px',
                  }}
                >
                  Last Updated
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    ...poppins400,
                    fontSize: '14px',
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    padding: '16px',
                  }}
                >
                  Done
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    ...poppins400,
                    fontSize: '14px',
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                    padding: '16px',
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {checkListArray.map((task, index) => {
                const icon = renderIcon(task?.taskName);
                const formattedLastUpdated =
                  task?.taskCode == 'SignCon001' &&
                  task?.taskStatus == 'Action Required'
                    ? formatLastUpdated()
                    : formatLastUpdated(task?.statusLastUpdatedAt);
                const statusIcon = determineStatusIcon(task);
                const formattedETA = task?.ETA
                  ? moment(task?.ETA).format('hh:mm A DD-MM-YYYY')
                  : '--';

                if (
                  (task?.taskCode == 'SignCon001' ||
                    task?.taskCode == 'DepPay001') &&
                  task?.isChecklist == 0
                ) {
                  return null;
                }

                return (
                  <TableRow
                    key={index}
                    sx={{
                      ...poppins300,
                      fontSize: '20px',
                    }}
                  >
                    <TableCell
                      align="center"
                      sx={{
                        width: matches420 ? '235px' : '300px',
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        padding: '16px',
                      }}
                    >
                      <Stack direction={'row'} gap={1} aligntasks={'center'}>
                        {icon}
                        <Typography
                          onClick={(event) =>
                            checkListPop(
                              task?.taskName,
                              icon,
                              index,
                              event,
                              task,
                              formattedETA,
                              formattedLastUpdated
                            )
                          }
                          sx={{
                            ...poppins300,
                            fontSize: matches420
                              ? '16px'
                              : matches650
                              ? '18px'
                              : '20px',
                            marginLeft: '15px',
                            color: '#112347',
                            cursor: 'pointer',
                          }}
                        >
                          {task?.taskName == '66w Certificate'
                            ? 's66W Certificate'
                            : task?.taskName}
                        </Typography>
                      </Stack>
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        padding: '22px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: getColor(
                            task?.taskStatus,
                            task?.taskName
                          ),
                          borderRadius: '5px',
                          ...poppins400,
                          fontSize: '16px',
                          color: '#FFFFFF',
                          whiteSpace: 'nowrap',
                          height: '28px',
                          padding: '4px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: '90%',
                        }}
                      >
                        {task?.ETA != null &&
                        (task?.taskStatus == 'In Progress' ||
                          task?.taskStatus == 'Requested')
                          ? 'ETA'
                          : task?.taskStatus}{' '}
                        &nbsp;
                        {task?.ETA != null &&
                          (task?.taskStatus == 'In Progress' ||
                            task?.taskStatus == 'Requested') && (
                            <>{formattedETA}</>
                          )}
                      </Box>
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        padding: '16px',
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontFamily: 'poppins',
                          fontWeight: '400',
                          fontSize: '12px',
                        }}
                      >
                        {formattedLastUpdated}
                      </Typography>
                    </TableCell>
                    <TableCell
                      sx={{
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        padding: '16px',
                      }}
                    >
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        width="100%"
                      >
                        {statusIcon}
                      </Box>
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        borderBottom: '1px solid rgba(224, 224, 224, 1)',
                        padding: '16px',
                      }}
                    >
                      <ActionButtonChecklist
                        ApicallDueDiligence={ApicallDueDiligence}
                        groupCall={groupCall}
                        data={data}
                        task={task}
                        checkListArray={checkListArray}
                        getBuyerIndividualData={getBuyerIndividualData}
                        getBuyerIndividualValue={getBuyerIndividualValue}
                        sharedpage={sharedpage}
                        openMessage={openMessage}
                        setContractReviewed={setContractReviewed}
                        setDueDiligence={setDueDiligence}
                        setOpenlogin={setOpenlogin}
                        openlogin={openlogin}
                        propertyInspected={propertyInspected}
                        setPropertyInspected={setPropertyInspected}
                        userId={userId}
                        setTabDAta={setTabDAta}
                        handleMakeOfferClick={handleMakeOfferClick}
                        action={action}
                        classes={classes}
                        uploadDoc={uploadDoc}
                        commenceBinder={commenceBinder}
                        setPaymentPop={setPaymentPop}
                        setOpenBoxSign={setOpenBoxSign}
                        depositPaymentBuyer={depositPaymentBuyer}
                        setDepositPaymentBuyer={setDepositPaymentBuyer}
                        signContract={signContract}
                        setSignContract={setSignContract}
                        sixtySixWCertificate={sixtySixWCertificate}
                        setSixtySixWCertificate={setSixtySixWCertificate}
                        contractReviewed={contractReviewed}
                        viewContractBuyer={viewContractBuyer}
                        setViewContractBuyer={setViewContractBuyer}
                        dueDiligence={dueDiligence}
                        request_E_signIcon={request_E_signIcon}
                        commence_E_SignIcon={commence_E_SignIcon}
                        setRequesttoview={setRequesttoview}
                        setNewTabData={setNewTabData}
                        userDetail={userDetail}
                        setOpensolicitorpopup={setOpensolicitorpopup}
                        setTypeofsolicitorpopup={setTypeofsolicitorpopup}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};
